export type TutorCredentialsSchema = {
    WWCC: string,
    WWCCverified: boolean,
    InterviewVerified: boolean,
};

const nameofTutorCredentialsSchemaWWCC = "WWCC";
const nameofTutorCredentialsSchemaWWCCverified = "WWCCverified";
const nameofTutorCredentialsSchemaCollection = "TutorCredentials";
const nameofTutorCredentialsSchemaInterviewVerified = "InterviewVerified";

export {
    nameofTutorCredentialsSchemaWWCC,
    nameofTutorCredentialsSchemaWWCCverified,
    nameofTutorCredentialsSchemaCollection,
    nameofTutorCredentialsSchemaInterviewVerified,
};

export type TutorCredentialsView = TutorCredentialsSchema & {
    Id: string,
};